import React, { useState, useCallback } from "react";
import { formStyles as s, downloadBtnStyle, DownloadIcon, requiredInput } from "./formStyles";
import SignaturePad from "../components/SignaturePad";
import { displayDateFormat } from "../utils/format";





const UnderperformanceForm = ({ pdfUrl = "/static/pdffilters/Underperformance-meeting-plan.pdf" }) => {


  
  const [form, setForm] = useState({
    // Page 1 — Meeting Details
    date: "",
    time: "",
    location: "",
    attendees: "",
    reasonDD: "Select what reason for meeting",
    reasonText: "",
    // Page 2 — Background & Details
    backgroundDD: "Select Background Discussion",
    backgroundText: "",
    detailsDD: "Select Details Of Regarding",
    detailsText: "",
    // Page 3 — Next Steps
    nextStepsDD: "Select Next Steps",
    nextStepsText: "",
    // Page 3 — Task List (each row explicit)
    task1DD: "Select Task",
    task1Text: "",
    task1Date: "",
    task2DD: "Select Task",
    task2Text: "",
    task2Date: "",
    task3DD: "Select Task",
    task3Text: "",
    task3Date: "",
    task4DD: "Select Task",
    task4Text: "",
    task4Date: "",
    task5DD: "Select Task",
    task5Text: "",
    task5Date: "",
    task6DD: "Select Task",
    task6Text: "",
    task6Date: "",
    // Page 4 — Names
    cleanerName: "",
    managerName: "",
    witnessName: "",
  });

  // Signature data URLs
  const [signatures, setSignatures] = useState({
    manager: null,
    cleaner: null,
    witness: null,
  });

  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);

  const u = (field, value) => setForm((p) => ({ ...p, [field]: value }));

  const handleSigSave = useCallback((key) => (dataUrl) => {
    setSignatures((p) => ({ ...p, [key]: dataUrl }));
  }, []);

  const handleSigClear = useCallback((key) => () => {
    setSignatures((p) => ({ ...p, [key]: null }));
  }, []);

  const isValid = form.date && form.location.trim() && form.attendees.trim();


  const REASON_OPTIONS = ["Select what reason for meeting", "Lateness", "Work schedule", "Quality of work", "Insufficient notice when absent", "Client feedback", "General concerns", "Abandonment of work", "Change of work schedule and duties"];
const BACKGROUND_OPTIONS = ["Select Background Discussion", "Raised lateness", "Raised work schedule", "Raised quality of work", "Raised insufficient notice when absent", "Raised client feedback", "Raised general concerns", "Raised abandonment of work", "Raised change work schedule and duties"];
const DETAILS_OPTIONS = ["Select Details Of Regarding", "Verbal warning regarding", "First warning regarding", "Second warning regarding", "Final warning regarding", "Conduct training regarding", "Discussion regarding", "Improvement regarding"];
const NEXTSTEPS_OPTIONS = ["Select Next Steps", "First written warning", "Second written warning", "Final written warning", "Performance improvement plan", "Communication about issue", "Follow up of scheduled meeting"];
const TASK_OPTIONS = ["Select Task", "Record of meeting", "Prepare written warning", "Performance improvement plan", "Schedule next meeting", "Review", "Catch-ups", "Agree to sign"];
  

  const handleDownload = async () => {
    setDownloading(true);
    setError(null);
    try {
      const { PDFDocument, PDFName } = await import("pdf-lib");
      const pdfBytes = await fetch(pdfUrl).then((r) => {
        if (!r.ok) throw new Error("Could not load PDF template");
        return r.arrayBuffer();
      });
      const pdfDoc = await PDFDocument.load(pdfBytes);
      pdfDoc.setTitle(`Underperformance Meeting Plan - ${form.attendees}`);
      const f = pdfDoc.getForm();

      
      const setText = (name, val) => { try { f.getTextField(name).setFontSize(12).setText(val || ""); } catch (_) {} };

      const setDrop = (name, val) => {
        try { f.getDropdown(name).select(val); } catch (_) {}
      };

      // ── Page 1: Meeting Details ──
      setText("Dateheader", displayDateFormat(form.date));
      setText("Timeheader", form.time);
      setText("Location", form.location);
      setText("Attendees", form.attendees);
      setText("ReasonText", form.reasonText);
      setDrop("Dropdownreason", form.reasonDD);

      // ── Page 2: Background & Details ──
      setDrop("DropdownBackground", form.backgroundDD);
      setText("TextBackground", form.backgroundText);
      setDrop("DropdownDetails", form.detailsDD);
      setText("TextDetails", form.detailsText);

      // ── Page 3: Next Steps & Tasks ──
      setDrop("DropdownNextsteps", form.nextStepsDD);
      setText("TextNextsteps", form.nextStepsText);

      // Task Row 1
      setDrop("Dropdown1", form.task1DD);
      setText("Textrow1", form.task1Text);
      setText("Daterow1", form.task1Date ? displayDateFormat(form.task1Date) : "");

      // Task Row 2
      setDrop("Dropdown2", form.task2DD);
      setText("Textrow2", form.task2Text);
      setText("Daterow2", form.task2Date ? displayDateFormat(form.task2Date) : "");

      // Task Row 3
      setDrop("Dropdown3", form.task3DD);
      setText("Textrow3", form.task3Text);
      setText("Daterow3", form.task3Date ? displayDateFormat(form.task3Date) : "");

      // Task Row 4
      setDrop("Dropdown4", form.task4DD);
      setText("Textrow4", form.task4Text);
      setText("Daterow4", form.task4Date ? displayDateFormat(form.task4Date) : "");

      // Task Row 5
      setDrop("Dropdown5", form.task5DD);
      setText("Textrow5", form.task5Text);
      setText("Daterow5", form.task5Date ? displayDateFormat(form.task5Date) : "");

      // Task Row 6
      setDrop("Dropdown6", form.task6DD);
      setText("Textrow6", form.task6Text);
      setText("Daterow6", form.task6Date ? displayDateFormat(form.task6Date) : "");

      // ── Page 4: Names ──
      setText("TextManagerName", form.managerName);
      setText("TextCleanerName", form.cleanerName);
      setText("TextWitnessName", form.witnessName);

      // ── Signature embedding ──
      const embedSigOnPage = async (sigDataUrl, fieldName) => {
        if (!sigDataUrl) return;
        try {
          const base64 = sigDataUrl.split(",")[1];
          const sigBytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
          const sigImage = await pdfDoc.embedPng(sigBytes);

          const sigField = f.getTextField(fieldName);
          const widgets = sigField.acroField.getWidgets();
          if (widgets.length === 0) return;

          const widget = widgets[0];
          const rect = widget.getRectangle();

          const pages = pdfDoc.getPages();
          let targetPage = null;

          for (const page of pages) {
            const annotsRef = page.node.get(PDFName.of("Annots"));
            if (!annotsRef) continue;
            const annots = page.node.context.lookup(annotsRef);
            if (!annots) continue;
            const arr = annots.asArray ? annots.asArray() : [];
            for (const ref of arr) {
              if (ref === widget.ref) { targetPage = page; break; }
            }
            if (targetPage) break;
          }

          if (!targetPage) {
            for (const page of pages) {
              const annotsRef = page.node.get(PDFName.of("Annots"));
              if (!annotsRef) continue;
              const annots = page.node.context.lookup(annotsRef);
              if (!annots) continue;
              const arr = annots.asArray ? annots.asArray() : [];
              for (const ref of arr) {
                const resolved = page.node.context.lookup(ref);
                if (resolved === widget.dict) { targetPage = page; break; }
              }
              if (targetPage) break;
            }
          }

          if (!targetPage) targetPage = pages[pages.length - 1];

          f.removeField(sigField);

          const aspectRatio = sigImage.width / sigImage.height;
          let drawWidth = rect.width;
          let drawHeight = drawWidth / aspectRatio;
          if (drawHeight > rect.height) {
            drawHeight = rect.height;
            drawWidth = drawHeight * aspectRatio;
          }

          const x = rect.x + (rect.width - drawWidth) / 2;
          const y = rect.y + (rect.height - drawHeight) / 2;

          targetPage.drawImage(sigImage, { x, y, width: drawWidth, height: drawHeight });
        } catch (e) {
          console.error(`Sig embed failed for ${fieldName}:`, e);
          try { f.getTextField(fieldName).setText("[Signed]"); } catch (_) {}
        }
      };

      await embedSigOnPage(signatures.manager, "SignManager");
      await embedSigOnPage(signatures.cleaner, "SignCleaner");
      await embedSigOnPage(signatures.witness, "SignWitness");

      // ── Flatten and save ──
      f.flatten();
      const filled = await pdfDoc.save();
      const blob = new Blob([filled], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `Underperformance-Meeting-${form.attendees || "Form"}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error("PDF fill error:", err);
      setError(err.message || "Failed to generate PDF");
    } finally {
      setDownloading(false);
    }
  };

  const handleReset = () => {
    setForm({
      date: "", time: "", location: "", attendees: "",
      reasonDD: "Select what reason for meeting", reasonText: "",
      backgroundDD: "Select Background Discussion", backgroundText: "",
      detailsDD: "Select Details Of Regarding", detailsText: "",
      nextStepsDD: "Select Next Steps", nextStepsText: "",
      task1DD: "Select Task", task1Text: "", task1Date: "",
      task2DD: "Select Task", task2Text: "", task2Date: "",
      task3DD: "Select Task", task3Text: "", task3Date: "",
      task4DD: "Select Task", task4Text: "", task4Date: "",
      task5DD: "Select Task", task5Text: "", task5Date: "",
      task6DD: "Select Task", task6Text: "", task6Date: "",
      cleanerName: "", managerName: "", witnessName: "",
    });
    setSignatures({ manager: null, cleaner: null, witness: null });
    setError(null);
  };

  return (
    <div style={s.wrapper}>
      <style>{s.spinKeyframes}</style>
      <h2 style={s.title}>Under Performance Meeting Plan</h2>
      <p style={s.subtitle}>Fill out the meeting plan and download the completed PDF</p>

      {/* ── Page 1: Meeting Details ── */}
      <div style={s.section}>
        <p style={s.pageLabel}>Page 1 — Meeting Details</p>
        <div style={s.sectionLabel}>Details</div>
        <div style={s.fieldGrid2}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Date *</label>
            <input style={requiredInput(form.date)} type="date" value={form.date} onChange={(e) => u("date", e.target.value)} />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Time</label>
            <input style={s.input} type="time" value={form.time} onChange={(e) => u("time", e.target.value)} />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Location *</label>
            <input style={requiredInput(form.location)} value={form.location} onChange={(e) => u("location", e.target.value)} placeholder="Meeting location" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Attendees *</label>
            <input style={requiredInput(form.attendees)} value={form.attendees} onChange={(e) => u("attendees", e.target.value)} placeholder="People attending" />
          </div>
        </div>
        <div style={{ marginTop: 14 }}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Reason for the Meeting</label>
            <select
              style={s.input}
              value={form.reasonDD}
              onChange={(e) => u("reasonDD", e.target.value)}
            >
              {REASON_OPTIONS.map((opt) => (
                <option key={opt} value={opt} style={s.optionStyle}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>Reason Details</label>
          <textarea style={s.textareaLarge} value={form.reasonText} onChange={(e) => u("reasonText", e.target.value)} placeholder="Describe the reason for the meeting..." />
        </div>
      </div>

      <hr style={s.divider} />

      {/* ── Page 2: Background & Details ── */}
      <div style={s.section}>
        <p style={s.pageLabel}>Page 2 — Background & Details</p>
        <div style={s.sectionLabel}>Background</div>
        <div style={s.fieldGroup}>
          <label style={s.label}>Background Discussion</label>
          <select
            style={s.input}
            value={form.backgroundDD}
            onChange={(e) => u("backgroundDD", e.target.value)}
          >
            {BACKGROUND_OPTIONS.map((opt) => (
              <option key={opt} value={opt} style={s.optionStyle}>
                {opt}
              </option>
            ))}
          </select>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>Background Details</label>
          <textarea style={s.textareaLarge} value={form.backgroundText} onChange={(e) => u("backgroundText", e.target.value)} placeholder="Describe the background..." />
        </div>
        <div style={s.sectionLabel}>Details</div>
        <div style={s.fieldGroup}>
          <label style={s.label}>Details Regarding</label>
          <select
            style={s.input}
            value={form.detailsDD}
            onChange={(e) => u("detailsDD", e.target.value)}
          >
            {DETAILS_OPTIONS.map((opt) => (
              <option key={opt} value={opt} style={s.optionStyle}>
                {opt}
              </option>
            ))}
          </select>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>Detail Notes</label>
          <textarea style={s.textareaLarge} value={form.detailsText} onChange={(e) => u("detailsText", e.target.value)} placeholder="Describe the details..." />
        </div>
      </div>

      <hr style={s.divider} />

      {/* ── Page 3: Next Steps & Tasks ── */}
      <div style={s.section}>
        <p style={s.pageLabel}>Page 3 — Next Steps & Tasks</p>
        <div style={s.sectionLabel}>Next Steps</div>
        <div style={s.fieldGroup}>
          <label style={s.label}>Next Steps</label>
          <select
            style={s.input}
            value={form.nextStepsDD}
            onChange={(e) => u("nextStepsDD", e.target.value)}
          >
            {NEXTSTEPS_OPTIONS.map((opt) => (
              <option key={opt} value={opt} style={s.optionStyle}>
                {opt}
              </option>
            ))}
          </select>
        </div>
        <div style={{ ...s.fieldFull, marginTop: 14 }}>
          <label style={s.label}>Next Steps Details</label>
          <textarea style={s.textarea} value={form.nextStepsText} onChange={(e) => u("nextStepsText", e.target.value)} placeholder="Describe next steps..." />
        </div>

        <div style={s.sectionLabel}>Task List</div>

        {/* Task Row 1 */}
        <div style={s.fieldGrid3}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Task 1</label>
            <select style={s.input} value={form.task1DD} onChange={(e) => u("task1DD", e.target.value)}>
              {TASK_OPTIONS.map((opt) => (<option key={opt} value={opt} style={s.optionStyle}>{opt}</option>))}
            </select>
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>What You Need to Do</label>
            <input style={s.input} value={form.task1Text} onChange={(e) => u("task1Text", e.target.value)} placeholder="Action required" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Due Date</label>
            <input style={s.input} type="date" value={form.task1Date} onChange={(e) => u("task1Date", e.target.value)} />
          </div>
        </div>

        {/* Task Row 2 */}
        <div style={{ ...s.fieldGrid3, marginTop: 10 }}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Task 2</label>
            <select style={s.input} value={form.task2DD} onChange={(e) => u("task2DD", e.target.value)}>
              {TASK_OPTIONS.map((opt) => (<option key={opt} value={opt} style={s.optionStyle}>{opt}</option>))}
            </select>
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>What You Need to Do</label>
            <input style={s.input} value={form.task2Text} onChange={(e) => u("task2Text", e.target.value)} placeholder="Action required" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Due Date</label>
            <input style={s.input} type="date" value={form.task2Date} onChange={(e) => u("task2Date", e.target.value)} />
          </div>
        </div>

        {/* Task Row 3 */}
        <div style={{ ...s.fieldGrid3, marginTop: 10 }}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Task 3</label>
            <select style={s.input} value={form.task3DD} onChange={(e) => u("task3DD", e.target.value)}>
              {TASK_OPTIONS.map((opt) => (<option key={opt} value={opt} style={s.optionStyle}>{opt}</option>))}
            </select>
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>What You Need to Do</label>
            <input style={s.input} value={form.task3Text} onChange={(e) => u("task3Text", e.target.value)} placeholder="Action required" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Due Date</label>
            <input style={s.input} type="date" value={form.task3Date} onChange={(e) => u("task3Date", e.target.value)} />
          </div>
        </div>

        {/* Task Row 4 */}
        <div style={{ ...s.fieldGrid3, marginTop: 10 }}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Task 4</label>
            <select style={s.input} value={form.task4DD} onChange={(e) => u("task4DD", e.target.value)}>
              {TASK_OPTIONS.map((opt) => (<option key={opt} value={opt} style={s.optionStyle}>{opt}</option>))}
            </select>
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>What You Need to Do</label>
            <input style={s.input} value={form.task4Text} onChange={(e) => u("task4Text", e.target.value)} placeholder="Action required" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Due Date</label>
            <input style={s.input} type="date" value={form.task4Date} onChange={(e) => u("task4Date", e.target.value)} />
          </div>
        </div>

        {/* Task Row 5 */}
        <div style={{ ...s.fieldGrid3, marginTop: 10 }}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Task 5</label>
            <select style={s.input} value={form.task5DD} onChange={(e) => u("task5DD", e.target.value)}>
              {TASK_OPTIONS.map((opt) => (<option key={opt} value={opt} style={s.optionStyle}>{opt}</option>))}
            </select>
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>What You Need to Do</label>
            <input style={s.input} value={form.task5Text} onChange={(e) => u("task5Text", e.target.value)} placeholder="Action required" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Due Date</label>
            <input style={s.input} type="date" value={form.task5Date} onChange={(e) => u("task5Date", e.target.value)} />
          </div>
        </div>

        {/* Task Row 6 */}
        <div style={{ ...s.fieldGrid3, marginTop: 10 }}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Task 6</label>
            <select style={s.input} value={form.task6DD} onChange={(e) => u("task6DD", e.target.value)}>
              {TASK_OPTIONS.map((opt) => (<option key={opt} value={opt} style={s.optionStyle}>{opt}</option>))}
            </select>
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>What You Need to Do</label>
            <input style={s.input} value={form.task6Text} onChange={(e) => u("task6Text", e.target.value)} placeholder="Action required" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Due Date</label>
            <input style={s.input} type="date" value={form.task6Date} onChange={(e) => u("task6Date", e.target.value)} />
          </div>
        </div>
      </div>

      <hr style={s.divider} />

      {/* ── Page 4: Signatures ── */}
      <div style={s.section}>
        <p style={s.pageLabel}>Page 4 — Signatures</p>
        <div style={s.sectionLabel}>Signatures</div>
        <div style={s.signatureGrid}>
          <div style={s.signatureBlock}>
            <span style={{
              ...s.signatureLabel,
              color: signatures.manager ? "rgba(255,255,255,0.6)" : "rgba(239,68,68,0.7)"
            }}>
              Manager Signature
            </span>
            <SignaturePad label="" width={300} height={120} onSave={handleSigSave("manager")} onClear={handleSigClear("manager")} />
          </div>
          <div style={s.signatureBlock}>
            <span style={{
              ...s.signatureLabel,
              color: signatures.cleaner ? "rgba(255,255,255,0.6)" : "rgba(239,68,68,0.7)"
            }}>
              Cleaner Signature
            </span>
            <SignaturePad label="" width={300} height={120} onSave={handleSigSave("cleaner")} onClear={handleSigClear("cleaner")} />
          </div>
          <div style={s.signatureBlock}>
            <span style={{
              ...s.signatureLabel,
              color: signatures.witness ? "rgba(255,255,255,0.6)" : "rgba(239,68,68,0.7)"
            }}>
              Witness Signature
            </span>
            <SignaturePad label="" width={300} height={120} onSave={handleSigSave("witness")} onClear={handleSigClear("witness")} />
          </div>
        </div>

        <div style={{ ...s.sectionLabel, marginTop: 20 }}>Names</div>
        <div style={s.fieldGrid3}>
          <div style={s.fieldGroup}>
            <label style={s.label}>Manager Name</label>
            <input style={s.input} value={form.managerName} onChange={(e) => u("managerName", e.target.value)} placeholder="Manager name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Cleaner Name</label>
            <input style={s.input} value={form.cleanerName} onChange={(e) => u("cleanerName", e.target.value)} placeholder="Cleaner name" />
          </div>
          <div style={s.fieldGroup}>
            <label style={s.label}>Witness Name</label>
            <input style={s.input} value={form.witnessName} onChange={(e) => u("witnessName", e.target.value)} placeholder="Witness name" />
          </div>
        </div>
      </div>

      <div style={s.btnRow}>
        <button style={downloadBtnStyle(isValid)} onClick={handleDownload} disabled={!isValid || downloading}>
          {downloading ? (<><span style={s.spinner} /> Generating PDF...</>) : (<><DownloadIcon /> Download Filled PDF</>)}
        </button>
        <button style={s.resetBtn} onClick={handleReset}>Reset</button>
      </div>
      {error && <div style={s.error}>{error}</div>}
    </div>
  );
};

export default UnderperformanceForm;